<script setup lang="ts">
    import { useRoute } from 'vue-router';
    import { inject, ref } from 'vue';
import { formatAmount, formatDateFrench } from '@/utils';

    const BACKEND_URL = inject('BACKEND_URL');
    const route = useRoute();
    const startupinfos: any = route.meta.startup_datas;
    const user: any = startupinfos.user;
    const prelevements: any[] = startupinfos.prelevements;
    const loading = ref(false);
    const errorMessage = ref('');
</script>
<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-40"></div>

        <h4 class="s7 font-semibold px-3 pb-5">Membre / Revolving <span class="text-sm text-grey-500"></span></h4>
        <div class="s13 flex-right gap-3 mt--2 mb-5 px-5">
            <span class="btn shadow-200 white2">Souscription</span>
            <span class="btn shadow-200 white2">Contrat</span>
            <span class="btn shadow-200 light2 border-none">Prélèvement</span>
            <span class="btn shadow-200 light2 border-none">Premier prélèvement</span>
            <span class="btn shadow-200 light2 border-none">Décaissement mensuel</span>
            <span class="btn shadow-200 light2 border-none">Wallet / Utilisation</span>
        </div>

        <!--User info - Component-->
        <div class="s20 widget flex align-items-center px-1 py-5">
            <div class="s2_mobile h-100p px-7">
                <div class="rounded-100 overflow-hidden item active"><!--active-->
                    <img :src="!!user.photo_url ? user.photo_url : '/assets/users_avatar/600w/user.jpg'" width="100%" />
                </div>
            </div>
            <div class="s4_mobile h-100p px-2">
                <h3 class="mb-2">C788PMKJ</h3>
                <h4>{{ user.nom + ' ' + user.prenom }}</h4>
            </div>
            <div class="s3_mobile h-100p px-2">
                <h4 class="font-normal mb-5">{{ user.collectivite?.nom }}</h4>
                <span class="tag-state warning stroke">En cours</span>
                <span class="tag-state notif stroke">Actif</span>
            </div>
            <div class="s4_mobile h-100p px-3">
                <h4 class="font-normal">
                    Date de fin de souscription <br class="mb-2"/>
                    <b class="text-2xl">{{ user.souscription ? formatDateFrench(user.souscription.date_fin) : '-' }}</b>
                </h4>
            </div>
            <div class="s7_mobile h-100p px-5">
                <!--Barre de progression - Component-->
                <div class="h-60 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                    <div class="widget-floating py-0 text-xl flex-right">Utilisation</div>
                    <div class="h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green" style="width: 25%;">
                        25%
                    </div>
                </div>
                <!--End Barre de progression-->
            </div>
        </div>
        <!--End User info-->

        <div class="clear-both h-20"></div>


        <!--Décaissement mensuel - Component-->
        <div class="s20 widget px-6 pt-8 pb-2">
            <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
                <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                    <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                    <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                    Décaissement mensuel
                </span>
            </div>
            <div class="s10 mt--5-5 flex-right gap-4" v-if="prelevements.length > 0">
                <!-- <button class="btn lg py-3 white2 active">
                    <img src="/icons/icon-consulter.svg" class="btn-icon" alt="" />
                    <span>Revolving</span>
                </button> -->
                <button class="btn lg py-3 black active">
                    <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                    <span>Exporter en PDF</span>
                </button>
                <button class="btn lg py-3 black active">
                    <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                    <span>Exporter en Excel</span>
                </button>
            </div>

            <div class="s20 items-center gap-6 px-5 pb-4 collapse-content active">
                <div class="clear-both h-15"></div>
                <template v-if="prelevements.length > 0">
                    <div class="flex items-center gap-6">
                        <div class="s7">
                            <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                                <div class="circle-medium bg-color-1000"></div>
                                Débloqué
                            </h5>
                            <h1 class="secondary-font font-semibold text-grey-900 my-2">184 350 F</h1>
                            <h5 class="secondary-font font-semibold text-grey-700 mb-4">+4.6%</h5>
                            <!--Barre de progression - Component-->
                            <div class="h-40 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                                <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white" style="width: 4.6%;">
                                    4.6%
                                </div>
                            </div>
                            <!--End Barre de progression-->
                        </div>
                        <div class="s7">
                            <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                                <div class="circle-medium bg-purple"></div>
                                Bloqué
                            </h5>
                            <h1 class="secondary-font font-semibold text-grey-900 my-2">184 350 F</h1>
                            <h5 class="secondary-font font-semibold text-grey-700 mb-4">95.4%</h5>
                            <!--Barre de progression - Component-->
                            <div class="h-40 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                                <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white" style="width: 95.4%;">
                                    95.4%
                                </div>
                            </div>
                            <!--End Barre de progression-->
                        </div>
                        <div class="s6">
                            <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                                <div class="circle-medium bg-green-light"></div>
                                Total
                            </h5>
                            <h1 class="secondary-font font-semibold text-grey-900 my-2">4 000 350 F</h1>
                            <h5 class="secondary-font font-semibold text-grey-700 mb-4">100%</h5>
                            <!--Barre de progression - Component-->
                            <div class="h-40 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                                <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light" style="width: 100%;">
                                    100%
                                </div>
                            </div>
                            <!--End Barre de progression-->
                        </div>
                    </div>

                    <div class="clear-both h-30"></div>

                    <div class="grid4 px-1">
                        <!--Décaissement - Component-->
                        <div class="widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5" :class="{'active': prelevement.status_prelevement == 'validated', 'opacity-6': prelevement.status_prelevement == 'pending'}" v-for="(prelevement, index) of prelevements" :key="'prelevement_' + index">
                            <div class="s10">
                                <h6 class="secondary-font font-semibold mb-1">{{ formatDateFrench(prelevement.periode_prelevement) }}</h6>
                                <h3 class="secondary-font font-semibold text-grey-900 py-1">{{ formatAmount(prelevement.montant_prelevement_expected) }} F</h3>
                                <p class="secondary-font font-semibold text-purple">1.5%</p>
                            </div>
                            <div class="s10 text-right">
                                <h5 class="secondary-font font-semibold text-primary-color pb-1 display-none">{{ prelevement.eta }}</h5>
                                <div class="mb-4" v-if="prelevement.status_prelevement == 'validated'">
                                    <span class="tag-state notif stroke">Effectué</span>
                                </div>
                                <p class="secondary-font font-semibold text-grey-600 pt-1">Date de déblocage</p>
                                <h6 class="secondary-font font-semibold text-grey-600 py-1">11 Déc. 2025</h6>
                            </div>
                            <div class="s20 mt-2" v-if="prelevement.active">
                                <p class="s10 font-medium text-sm text-grey-600 mt-2">
                                    Prélèvement <span class="text-sm color-success">(Effectué)</span>
                                </p>
                                <div class="s10">
                                    <button class="btn-ultra w-100">
                                        <div class="btn-show">
                                            <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                                            <span>Décaisser</span>
                                        </div>
                                        <div class="btn-loading">
                                            <div class="loader-dots"></div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!--End Décaissement-->

                    </div>

                    <div class="clear-both h-15"></div>
                    <span class="px-5 py-4 bg-color rounded-100 font-bold text-lg collapse-open active align-right">
                        <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                        <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                        Voir tous
                    </span>
                </template>
                <template v-if="prelevements.length == 0">
                    <div class="text-center">
                        <h6 class="secondary-font font-semibold mb-1">Aucun prélèvement trouvé</h6>
                    </div>
                </template>
            </div>

        </div>

        <div class="clear-both h-80"></div>

    </section>
</template>